import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';


import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { Integrante } from '../integrante/integrante.model';

export const entityIntegranteAdapter: EntityAdapter<Integrante> =
  createEntityAdapter<Integrante>({
    selectId: (model) => model.rol.id,
    sortComparer: (a: Integrante, b: Integrante): number =>
      b.rol.id.toString().localeCompare(a.rol.id.toString())
  });

export interface EntityIntegranteState extends EntityState<Integrante> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null;
}

export const initialState: EntityIntegranteState =
  entityIntegranteAdapter.getInitialState({
    isLoading: false,
    hasAddedSuccess: false,
    error: null
  });
